import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';


import customerList from './customer/list';
import customerDashboard from './customer/index';
import customerAdd from './customer/add';

import leadAdd from './lead/add';
import leadDashboard from './lead/index';
import leadList from './lead/list';
import leadListMulti from './lead/list/multi';
import leadListPending from './lead/list/pending';
import leadView from './lead/view';

import couponList from './coupon/index'
import couponView from './coupon/view'
const System = ({ match }) => (
    <div className="dashboard-wrapper">
        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/default`} />
            <Route path={`${match.url}/customer/add/:customerTagID`} component={customerAdd} />
            <Route path={`${match.url}/customer/list/:listType`} component={customerList} />
            <Route path={`${match.url}/customer/list`} component={customerList} />
            <Route path={`${match.url}/customer/:customerTagID/list/:listType`} component={customerList} />
            <Route path={`${match.url}/customer/:customerTagID/list`} component={customerList} />
            <Route path={`${match.url}/customer/:customerTagID`} component={customerDashboard} />
            <Route path={`${match.url}/customer`} component={customerDashboard} />

            <Route path={`${match.url}/lead/add`} component={leadAdd} />
            <Route path={`${match.url}/lead/view/:leadMobile`} component={leadView} />
            <Route path={`${match.url}/lead/list/multi`} component={leadListMulti} />
            <Route path={`${match.url}/lead/list/pending`} component={leadListPending} />
            <Route path={`${match.url}/lead/list/tag/:tagName`} component={leadList} />
            <Route path={`${match.url}/lead/list/:listType`} component={leadList} />
            <Route path={`${match.url}/lead`} component={leadDashboard} />
            {/* <Route path={`${match.url}/customer/list/:listType`} component={leadDashboard} /> */}

            <Route path={`${match.url}/coupon/view/:couponID`} component={couponView} />
            <Route path={`${match.url}/coupon/list`} component={couponList} />
            <Redirect to="/error" />
        </Switch>
    </div>
);
export default System;